// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-694a0bce]:hover{text-decoration:underline}.custom-input-obj[data-v-694a0bce]{border:0 none!important;outline:0;color:#00995d!important}", ""]);
// Exports
module.exports = exports;
